import { ClassNames, MonsterNames,LocationNames } from './NameEnums';

export enum MODIFIER_NAME {
    att = 0,
    def = 1,
    pierce = 2,
    hp = 3
}

export const PLAYER_CLASSES = [
    {
        name: ClassNames.ARCHER,
        spriteM: 'Archer-m.png',
        spriteF: 'Archer-f.png',
        att: 1,
        def: 0,
        pierce: 1,
        hp: -1,
        potion: 1
    },
    {
        name: ClassNames.KNIGHT,
        spriteM: 'Knight-m.png',
        spriteF: 'Knight-f.png',
        att: -1,
        def: 2,
        pierce: 0,
        hp: 0,
        potion: 1
    },
    {
        name: ClassNames.WIZARD,
        spriteM: 'Wizard-m.png',
        spriteF: 'Wizard-f.png',
        att: 3,
        def: -2,
        pierce: 0,
        hp: -1,
        potion: 2
    },
    {
        name: ClassNames.BOXER,
        spriteM: 'Boxer-m.png',
        spriteF: 'Boxer-f.png',
        att: 2,
        def: -2,
        pierce: 0,
        hp: 1,
        potion: 1
    }
];

// add monsters when we get more assets, and possibly expand the properties
export const MONSTER_CLASSES = [
    {
        name: MonsterNames.SLIME,
        sprite: 'slime.png',
        boss: false,
        att: 0,
        def: 0,
        pierce: 0,
        hp: 0
    },
    {
        name: MonsterNames.BATS,
        sprite: 'bats.png',
        boss: false,
        att: 2,
        def: 0,
        pierce: 0,
        hp: 0
    },
    {
        name: MonsterNames.SKELETON_HORSE,
        sprite: 'skeleton-horse.png',
        boss: false,
        att: 0,
        def: 1,
        pierce: 0,
        hp: 1
    },
    {
        name: MonsterNames.DRAGON,
        sprite: 'dragon.png',
        boss: true,
        att: 2,
        def: 2,
        pierce: 1,
        hp: 1
    },
    {
        name: MonsterNames.WEREWOLF,
        sprite: 'werewolf.png',
        boss: false,
        att: 0,
        def: 0,
        pierce: 0,
        hp: 3
    },
    {
        name: MonsterNames.CRABBO,
        sprite: 'crab.png',
        boss: false,
        att: 1,
        def: 2,
        pierce: 0,
        hp: 0
    },
    {
        name: MonsterNames.SKULL,
        sprite: 'flaming-skull.png',
        boss: false,
        att: 1,
        def: 1,
        pierce: 0,
        hp: 0
    },
    {
        name: MonsterNames.BANDIT,
        sprite: 'bandit.png',
        boss: false,
        att: 1,
        def: 0,
        pierce: 0,
        hp: 1
    },
    {
        name: MonsterNames.MINUTAUR,
        sprite: 'minotaur.png',
        boss: true,
        att: 2,
        def: 1,
        pierce: 1,
        hp: 1
    },
    {
        name: MonsterNames.HYDRA,
        sprite: 'hydra.png',
        boss: false,
        att: 1,
        def: 0,
        pierce: 1,
        hp: 0
    },
    {
        name: MonsterNames.ICE_HYDRA,
        sprite: 'ice_hydra.png',
        boss: false,
        att: 0,
        def: 0,
        pierce: 2,
        hp: 0
    },
    {
        name: MonsterNames.MIND_FLAYER,
        sprite: 'mind_flayer.png',
        boss: true,
        att: 5,
        def: -1,
        pierce: 0,
        hp: -1
    },
    {
        name: MonsterNames.GOBLIN_STACK,
        sprite: 'goblin_stack.png',
        boss: false,
        att: 1,
        def: -1,
        pierce: -1,
        hp: 1
    }
];

export const LOCATION_CLASSES = [
    {
        name: LocationNames.FOREST,
        sprite: 'forest-background.gif'
    },
    {
        name: LocationNames.DUNGEON,
        sprite: 'dungeon-background.gif'
    }
]